const isProduction = process.env.NEXT_PUBLIC_COOKIE_DOMAIN ? process.env.NEXT_PUBLIC_COOKIE_DOMAIN.includes("gallabox.com") : true;

const siteUrl = isProduction ? "https://gallabox.com" : "https://gallabox.dev";

module.exports = { isProduction, siteUrl };
